var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.75 9.77007V14.1138C14.75 14.4584 14.4696 14.7388 14.125 14.7388H1.875C1.53038 14.7388 1.25 14.4584 1.25 14.1138V9.77007H0V14.1138C0 15.1477 0.841125 15.9888 1.875 15.9888H14.125C15.1589 15.9888 16 15.1477 16 14.1138V9.77007H14.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 0.0112L4.11615 3.89507L5.00002 4.77895L7.37502 2.40395V12.1451H8.62502V2.40395L11 4.77895L11.8839 3.89507L8.00002 0.0112Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.5a807535f084dbf243413c04bc74bfbb.svg";
export { ForwardRef as ReactComponent };